export default "__VITE_ASSET__92c277d5__"